"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uxcore = require("@ux/uxcore2");

var _duration = _interopRequireDefault(require("@upp/shared-components/lib/basket/duration"));

var _multiyearPrice = _interopRequireDefault(require("@upp/shared-components/lib/basket/multiyearPrice"));

var _constants = require("../utils/constants");

var _helpers = require("../utils/helpers");

var _namespaceComponent = require("@ux/namespace-component");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Item =
/*#__PURE__*/
function (_NamespaceConsumer) {
  _inherits(Item, _NamespaceConsumer);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, _getPrototypeOf(Item).apply(this, arguments));
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          onDelete = _this$props.onDelete,
          onDurationChange = _this$props.onDurationChange,
          market = _this$props.market,
          currency = _this$props.currency,
          language = _this$props.language;
      var title = item.label;
      var subtitle = null;
      var isOneTimeFee = item.periodUnit === _constants.PeriodUnits.ONE_TIME;

      if (item.metadata && item.metadata.domains && item.metadata.domains.length === 1) {
        subtitle = item.metadata.domains[0].domain;
      }

      if (item.metadata && item.metadata.domains && item.metadata.domains.length > 1) {
        subtitle = item.metadata.domains.map(function (d) {
          return d.domain;
        }).join(', ');
      }

      return _react["default"].createElement("div", {
        className: this.namespace('hc-item item card ux-card')
      }, _react["default"].createElement("div", {
        className: this.namespace('hc-item-header bg-faint')
      }, _react["default"].createElement("div", {
        className: this.namespace('hc-item-header-text')
      }, _react["default"].createElement("div", {
        className: this.namespace('ms-1')
      }, _react["default"].createElement("strong", null, title)), _react["default"].createElement("div", {
        className: this.namespace('ms-1 text-muted')
      }, subtitle)), _react["default"].createElement(_uxcore.Button, {
        design: "tertiary",
        onClick: onDelete,
        "data-eid": "gce.header_cart.sales_header.item_delete.click"
      }, _react["default"].createElement("span", {
        className: this.namespace('uxicon uxicon-trash align-top ms-1')
      }))), _react["default"].createElement("div", {
        className: this.namespace('hc-item-editor')
      }, _react["default"].createElement("div", null, !isOneTimeFee && _react["default"].createElement("div", {
        className: this.namespace('ms-1')
      }, _react["default"].createElement("strong", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:purchaseLength"
      }))), _react["default"].createElement("div", {
        className: this.namespace('ms-2 text-muted')
      }, _react["default"].createElement(_multiyearPrice["default"], {
        design: "inline",
        item: item,
        currency: currency,
        itemPricing: item.pricing,
        market: market,
        language: language
      }))), _react["default"].createElement("div", {
        className: this.namespace('hc-duration')
      }, !isOneTimeFee && _react["default"].createElement(_duration["default"], {
        hideLabel: true,
        hidePrice: true,
        item: item,
        currency: currency,
        market: market,
        eid: 'gce.header_cart.sales_header.',
        language: language,
        selectedValue: item.period,
        onChange: onDurationChange
      }), _react["default"].createElement("span", {
        className: this.namespace('text-success')
      }, _react["default"].createElement("strong", null, (0, _helpers.formatPrice)(market, currency, item.pricing.subtotal))))));
    }
  }]);

  return Item;
}(_namespaceComponent.NamespaceConsumer);

Item.propTypes = {
  currency: _propTypes["default"].string.isRequired,
  item: _propTypes["default"].object.isRequired,
  market: _propTypes["default"].string.isRequired,
  onDelete: _propTypes["default"].func.isRequired,
  onDurationChange: _propTypes["default"].func.isRequired,
  language: _propTypes["default"].object.isRequired
};
var _default = Item;
exports["default"] = _default;